import { Component, Input } from '@angular/core';
import { ProductService } from '../../product.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { DataBagService } from 'src/app/common/data-bag.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-product-rooms-add',
	templateUrl: './product-rooms-add.component.html',
	styleUrls: ['./product-rooms-add.component.scss'],
})
export class ProductRoomsAddComponent {
	@Input() editable: boolean;
	disabled = false;
	subRooms: any = [];
	passRoomType: any = null;
	roomCount: number = null;
	passFee: number = null;
	passIsNoName = false;

	constructor(
		public service: ProductService,
		public infobox: InfoboxService,
		public bag: DataBagService,
		private readonly dialogRef: MatDialogRef<any>,
	) {}

	addSubRoom() {
		this.subRooms.push({
			roomType: null,
			fee: null,
			code: null,
		});
	}

	addRooms() {
		if (this.passFee == null || this.roomCount == null || this.passRoomType == null) {
			this.infobox.warning('Pamiętaj o uzupełnieniu swoich danych!');
			return;
		}

		if (this.roomCount > 35) {
			this.infobox.error('Wprowadziłeś za dużo pokoi na raz! Maksymalna ilość pokoi to 35');
			return;
		}

		const roomType = this.service.mockData.roomType.find((findObj) => findObj.id == this.passRoomType);

		this.subRooms.forEach((element) => {
			const findSubRoomType = this.service.mockData.roomType.find((findObj) => findObj.id == element.roomType);
			element.code = findSubRoomType.code;
			element.roomType = findSubRoomType;
		});
		const roomNumber = this.service.data.rooms.length ? this.service.data.rooms.length + 1 : 1;
		for (let i = 0; i < this.roomCount; i++) {
			this.service.data.rooms.push({
				description: '',
				fee: this.passFee,
				isActive: true,
				isNoName: this.passIsNoName,
				level: null,
				order: this.service.data.rooms.length + i,
				roomNumber: `${roomType.code}/${this.subRooms[0] ? this.subRooms[0].code : ''}`,
				roomSlaves: this.subRooms,
				roomType: roomType,
				codeName: roomType.code,
				view: null,
			});
		}

		this.infobox.warning('By zapisać konfigurację pokoi kliknij przycisk "zapisz i wyjdź"');

		this.dialogRef.close(true);
	}

	removeSubRoom(i: number) {
		this.subRooms.splice(i, 1);
	}

	convertPriceToGrosze(price: any) {
		return price * 100;
	}
}
